// import React from 'react';
// import NewLandingPage from '../newPages/NewLandingPage/NewLandingPage';
// import PublicProfilePage from '../newPages/PublicProfile/PublicProfilePage';
// import { getDomainRoutingInfo } from '../util/domainRouting';

// const SubdomainRouteRenderer = props => {
//     const { isOrgSubdomain, subdomain } = getDomainRoutingInfo();

//     if (isOrgSubdomain) {
//         return <PublicProfilePage {...props} organizationSlug={subdomain} />;
//     }

//     return <NewLandingPage {...props} />;
// };

// export default SubdomainRouteRenderer;

import React, { useEffect, useState } from 'react';
import NewLandingPage from '../newPages/NewLandingPage/NewLandingPage';
import PublicProfilePage from '../newPages/PublicProfile/PublicProfilePage';
import { getDomainRoutingInfo, ROOT_DOMAIN } from '../util/domainRouting';
import { getPublicPartnerProfileBySlug } from '../coreApi';

const SubdomainRouteRenderer = props => {
    const { isOrgSubdomain, subdomain } = getDomainRoutingInfo();
    const [loading, setLoading] = useState(true);
    const [canRender, setCanRender] = useState(false);

    useEffect(() => {
        let cancelled = false;

        const checkPublicProfile = async () => {
            if (!isOrgSubdomain || !subdomain) {
                setLoading(false);
                return;
            }

            try {
                await getPublicPartnerProfileBySlug(subdomain);

                if (!cancelled) {
                    setCanRender(true);
                    setLoading(false);
                }
            } catch (error) {
                if (!cancelled) {
                    window.location.replace(`https://${ROOT_DOMAIN}`);
                }
            }
        };

        checkPublicProfile();

        return () => {
            cancelled = true;
        };
    }, [isOrgSubdomain, subdomain]);

    if (isOrgSubdomain) {
        if (loading) return null;
        if (!canRender) return null;

        return <PublicProfilePage {...props} organizationSlug={subdomain} />;
    }

    return <NewLandingPage {...props} />;
};

export default SubdomainRouteRenderer;
